import React, {useEffect, useState} from "react";
import {DeskingTable} from "./DeskingTable";
import './DeskingPage.scss'
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import {DeskingPageLoading} from "./DeskingPageLoading";
import {useDeskingContext} from "../../contexts/DeskingContext";
import CancelSharpIcon from '@mui/icons-material/CancelSharp';
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {useUserContext} from "../../contexts/UserContext";
import Popover from "@mui/material/Popover";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import Stack from "@mui/material/Stack";
import {RebatesTable} from "../RebatesPage/RebatesTable";
import {Paper} from "@mui/material";


export const DeskingPage = ( { id, onSave, setIsOpen } ) => {
    const { profileState, setProfileStateWithUpdate } = useUserContext()
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const {
        deskingState,
        setDeskingStateWithUpdate,
        fetchDeskingResponse,
        updateDealResponse,
    } = useDeskingContext()
    const [anchorEl, setAnchorEl] = useState(null);

    const handleActionClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setAnchorEl(null);
    };

    const fetchDeskingWithRebates = (rebates, option_code_ids) => {
        const newState = {
            ...deskingState,
            rebates: rebates,
            option_code_ids: option_code_ids,
        }

        setDeskingStateWithUpdate(newState, true)
    }

    useEffect(function onDeskingSave(){
        if (updateDealResponse?.data?.data && !updateDealResponse.loading && !updateDealResponse.error) {
            onSave && onSave()
        }
    }, [updateDealResponse])


    if (fetchDeskingResponse?.loading && !deskingState?.quotes) {
        return <DeskingPageLoading/>
    }

    if (!deskingState) return null;

    const carDetail = deskingState?.car_detail
    const optionCodes = deskingState?.option_codes || []
    const isLoadingDesking = fetchDeskingResponse?.loading

    const sortBy = profileState.desking_sort_by
    const sortByText = {
        [sortBy === 'BestPayment']: 'Monthly Payment: Low to High',
        [sortBy === 'Lender']: 'Sort By Lender',
    }.true

    const headerTitle = {
        true: 'Lease',
        [deskingState.is_purchase]: 'Purchase',
        [deskingState.is_purchase && deskingState.is_one_pay]: 'Cash'
    }.true

    return (
        <div id="DeskingPage">
            <Box className={'DeskingPage-Box'}>
                {/*{*/}
                {/*    isTabletOrMobile &&*/}
                {/*    <CancelIcon*/}
                {/*        onClick={() => setIsOpen(null)}*/}
                {/*        sx={{*/}
                {/*            position: 'absolute',*/}
                {/*            color: '#A23325',*/}
                {/*            fontSize: '50px',*/}
                {/*            zIndex: '2000',*/}
                {/*            bottom: "50px",*/}
                {/*            left: '10px',*/}
                {/*            borderRadius: '50%',*/}
                {/*            filter: "drop-shadow(0 4px 6px rgba(0, 0, 0, 0.2))",*/}
                {/*        }}*/}
                {/*    />*/}
                {/*}*/}
                <Paper sx={{borderRadius: '8px', padding: '10px', opacity: isLoadingDesking ? .5 : 1}}>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography
                            className={'car-info'}
                            fontWeight={400}
                            variant="h5"
                            gutterBottom
                            style={{
                                fontSize: isTabletOrMobile ? '13px' : 'inherit'
                            }}
                        >
                            Quotes for
                            <strong> {carDetail.year} {carDetail.make} {carDetail.model} </strong>
                            {carDetail.trim} {` [${headerTitle}]`}
                            <div>{optionCodes.map(o => <span style={{fontSize: '12px'}}>{o.name}, </span>)}</div>
                        </Typography>
                        <Typography
                            className={'desking-sort__drop-down-item'}
                            onClick={handleActionClick}
                            fontSize={14}
                        >
                            {sortByText}
                            <ArrowDropDownIcon/>
                        </Typography>
                        <Popover
                            onClick={(e) => e.stopPropagation()}
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handleActionClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                horizontal: 'right',
                                vertical: 'top'
                            }}
                        >
                            <Typography
                                className={'desking-sort__drop-down-item'}
                                fontSize={14}
                                onClick={(e) => {
                                    setProfileStateWithUpdate({desking_sort_by: 'BestPayment'})
                                    handleActionClose(e)
                                }}
                            >
                                Monthly Payment: Low to High
                            </Typography>
                            <Typography
                                className={'desking-sort__drop-down-item'}
                                onClick={(e) => {
                                    setProfileStateWithUpdate({desking_sort_by: 'Lender'})
                                    handleActionClose(e)
                                }}
                                fontSize={14}
                            >
                                Sort By Lender
                            </Typography>
                        </Popover>

                    </Stack>

                    <DeskingTable dealState={deskingState} dealId={id}/>
                </Paper>

                <RebatesTable {...deskingState} applySelectedRebates={fetchDeskingWithRebates}/>
            </Box>
        </div>
    )
}